export default __webpack_public_path__ + "static/keyboard-3-seconds-e82bd3eb33ceb4b7f6b297f2c3978dc2.mp3";